import styles from './AllNotifications.module.scss'
import { useHistory } from 'react-router-dom'

import { useSelector, useDispatch } from 'react-redux'

import { SET_PAGINATION } from '../../../redux/actions/actionTypes'
import { searchExpertAction } from '../../../redux/actions/expertsActions'

import List from './List/index' // <-- The actual list renderer
import { Button, SearchInput } from '../../../components'
import PaginationRight from '../../../assets/icons/utils/paginationRight'
import PaginationLeft from '../../../assets/icons/utils/paginationLeft'

const AllNotification = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { search } = useSelector((state) => state.expertsReducer)
  const { count, pagination } = useSelector((state) => state.usersReducer)

  const infoTabs = ['Registration date', 'Message', 'Send To All Users']

  const addPage = () => {
    if (pagination < Math.ceil(count / 20)) {
      dispatch({ type: SET_PAGINATION, payload: pagination + 1 })
    }
  }

  const prevPage = () => {
    if (pagination > 1) {
      dispatch({ type: SET_PAGINATION, payload: pagination - 1 })
    }
  }

  return (
    <div className={styles.PROs}>
      <div className={styles.PROs__header}>
        <div className={styles.PROs__filters}>
          <div className={styles.bigTitle}>Manage Notifications</div>
          <div className={[styles.searchBlockButton]}>
            <Button onClick={() => history.push('/notifications/add')}>
              Send Notification
            </Button>
          </div>
          <div className={styles.searchBlock}>
            <SearchInput
              placeholder='Search'
              value={search}
              onChange={(value) => {
                dispatch(searchExpertAction(value))
                dispatch({ type: SET_PAGINATION, payload: 1 })
              }}
            />
          </div>
        </div>
      </div>

      {/* Column titles */}
      <div className={styles.PROs__infoBar}>
        {infoTabs.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>

      {/* Actual Notification List */}
      <List />

      {/* Pagination */}
      <div className={styles.pagination}>
        <div className={styles.paginationArrow} onClick={prevPage}>
          {PaginationLeft(
            pagination > 1 ? '#404247' : 'rgba(43, 45, 51, 0.24)'
          )}
        </div>
        <p className={styles.paginationCurrent}>{pagination}</p>
        <p>of</p>
        <p className={styles.paginationAll}>{Math.ceil(count / 20)}</p>
        <div className={styles.paginationArrow} onClick={addPage}>
          {PaginationRight(
            pagination < Math.ceil(count / 20)
              ? '#404247'
              : 'rgba(43, 45, 51, 0.24)'
          )}
        </div>
      </div>
    </div>
  )
}

export default AllNotification
